// Third Party
import React from 'react';
import classNames from 'classnames';

// Components
import { SelectInput, SelectOption } from '../inputs';
import { Tooltip } from '../tooltips';

type Props = {
  className?: string;
  title?: string;
  label?: string;
  onChange: (value: any) => void;
  selected?: any;
  options: {
    value: any;
    label: string;
  }[];
  disabled?: boolean;
  tooltipMessage?: string;
  placeholder?: string;
  tooltipDisabled?: boolean;
  dark?: boolean;
  showWarning?: boolean;
  warningMessage?: string;
  horizontalLabel?: boolean;
};

const BMOGIFPortfolioDropdown = ({ ...props }: Props) => {
  const {
    className,
    onChange,
    label,
    selected,
    options,
    title,
    disabled,
    tooltipMessage,
    placeholder,
    tooltipDisabled,
    dark,
    showWarning,
    warningMessage,
    horizontalLabel,
  } = props;

  return (
    <div className={classNames('d-flex flex-column', className)}>
      {title && (
        <div className={classNames('input-title', { disabled })}>
          <span>{title}</span>
        </div>
      )}

      <Tooltip message={tooltipMessage} disabled={tooltipDisabled}>
        <SelectInput
          compact
          className="select-input-v2 slim"
          dark={dark}
          label={label}
          placeholder={placeholder || '--'}
          selected={selected}
          onValueChange={onChange}
          disabled={disabled}
          showWarning={showWarning}
          warningMessage={warningMessage}
          horizontalLabel={horizontalLabel}
        >
          {options.map((option, i) => (
            <SelectOption key={`${i}-${option.value}`} value={option.value}>
              {option.label}
            </SelectOption>
          ))}
        </SelectInput>
      </Tooltip>
    </div>
  );
};

export default BMOGIFPortfolioDropdown;
